/**
 * Firebase web-app config: sign-in (lib/firebase.js) and, since 2026-10-26,
 * the device id, which is the Firebase Installation ID (services/deviceId.js).
 * The installations call needs apiKey, projectId and appId, and the project
 * needs the Firebase Installations API enabled.
 *
 * These are public identifiers, not secrets — every Firebase web app ships
 * them in its bundle, and the project is protected by Firebase Auth rules,
 * not by hiding them. Each field is read through envValue() — runtime
 * (Cloud Run --set-env-vars), then build-time, then the default — so another
 * environment can point at its own Firebase project. Unset, every field is
 * the value that was a literal in lib/firebase.js until 2026-10-09.
 */
import { envValue } from "./runtimeEnv";

export const FIREBASE_CONFIG = {
  apiKey:
    envValue("REACT_APP_FIREBASE_API_KEY", process.env.REACT_APP_FIREBASE_API_KEY) ||
    "AIzaSyBlBIMGAdBY7Azk244EXZ1_3-BJCpNHWmk",
  authDomain:
    envValue(
      "REACT_APP_FIREBASE_AUTH_DOMAIN",
      process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
    ) || "retail-jkommerce-poc.firebaseapp.com",
  projectId:
    envValue(
      "REACT_APP_FIREBASE_PROJECT_ID",
      process.env.REACT_APP_FIREBASE_PROJECT_ID
    ) || "retail-jkommerce-poc",
  storageBucket:
    envValue(
      "REACT_APP_FIREBASE_STORAGE_BUCKET",
      process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
    ) || "retail-jkommerce-poc.firebasestorage.app",
  messagingSenderId:
    envValue(
      "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
      process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
    ) || "218142584790",
  appId:
    envValue("REACT_APP_FIREBASE_APP_ID", process.env.REACT_APP_FIREBASE_APP_ID) ||
    "1:218142584790:web:4c10309ff56d1d4ca77e77",
  measurementId:
    envValue(
      "REACT_APP_FIREBASE_MEASUREMENT_ID",
      process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    ) || "G-J2TEKV4PZK",
};
